module.exports = __webpack_public_path__ + "static/media/DecCreditcardFraud.4894d02f.tsx";